import { Mic } from 'lucide-react'
import { useNavigate } from 'react-router'
import type { QuickAction, QuickMenuItem } from '@/components/patterns/QuickActions'
import { inspreekenHref } from './relation'
import type { CaptureContext } from './types'
import { useInsprekenStatus } from './useInsprekenStatus'

/**
 * The "Inspreken" entry of a relation page, as quick-action items. Both lists are empty
 * where Inspreken is off or its status cannot be loaded. With `inMore` the entry is a quick
 * action on a phone and an item of "Meer" from 768 px (one list, the breakpoint decides
 * with CSS); without it, it is a quick action everywhere.
 */
export function useInsprekenEntry(
  context: CaptureContext,
  options: { inMore?: boolean } = {},
): { quick: QuickAction[]; more: QuickMenuItem[] } {
  const navigate = useNavigate()
  const { available } = useInsprekenStatus()
  if (!available) return { quick: [], more: [] }
  const open = () => navigate(inspreekenHref(context))
  return {
    quick: [{ key: 'inspreken', label: 'Inspreken', icon: Mic, onClick: open, mobileOnly: options.inMore === true }],
    more: options.inMore ? [{ key: 'inspreken', label: 'Inspreken', onSelect: open, desktopOnly: true }] : [],
  }
}
